import { v4 as uuid } from "uuid";
import { useSelector, useDispatch } from 'react-redux'

import store, {history} from '@/redux/store';
import { createSlice, nanoid, createAsyncThunk } from '@reduxjs/toolkit'

export const TYPE_ALERT = "ALERT";
export const TYPE_INFO = "INFO";
export const ERROR = "ERROR";
export const SUCCESS = "SUCCESS";

export const MODAL_TYPE_ALERT = "alert";
export const MODAL_TYPE_TENANT_SELECT = "tenant_select";
export const MODAL_TYPE_TENANT_CHANGED = "tenant_changed";
export const MODAL_TYPE_DROPBOX_BASEMAP_SELECT = "dropbox_basemap_select"

import * as UserConst from "actions/userConst";
import messageSlice from "@/redux/messageSlice";

export const initialState = {
  showModal: false,
  header: "",
  description: "",
  type: TYPE_ALERT,
  modalType: null,
  data: null
};

import TenantAPI from "@/api/TenantAPI";

import { LOCATION_CHANGE } from 'react-router-redux';


export const loadTenants = createAsyncThunk(
  "tenant",
  // The payload creator receives the partial `{title, content, user}` object
  async (userId, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
      response = await TenantAPI.getAll();
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
      return response;
  }
)
export const switchTenant = createAsyncThunk(
  "switchtenant",
  // The payload creator receives the partial `{title, content, user}` object
  async (tenantId, event) => {
      //const {UserReducer, rejectWithValue} = event.getState();
      let response = null;
      try {
      response = await TenantAPI.switchTenant(tenantId);
      store.dispatch(messageSlice.actions.submitMessage({action: "SWITCH_TENANT", payload: tenantId }));
      if(response) {
      }
      return response.data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
  }
)


const ModalReducer = createSlice({
  name: 'modal',
  initialState,
  reducers: {
      alert(state, action) {
          state.showModal = true;
          state.header = action.payload.header;
          state.description = action.payload.description;
          state.type = TYPE_ALERT;
          state.modalType = MODAL_TYPE_ALERT;
      },
      info(state, action) {
          state.showModal = true;
          state.header = action.payload.header;
          state.description = action.payload.description;
          state.type = TYPE_INFO;
          state.modalType = MODAL_TYPE_ALERT;
          
      },
      success(state, action) {
          state.showModal = true;
          state.header = action.payload.header;
          state.description = action.payload.description;
          state.type = SUCCESS;
          state.modalType = MODAL_TYPE_ALERT;
          
      },      
      error(state, action) {
          state.showModal = true;
          state.header = action.payload.header;
          state.description = action.payload.description;
          state.type = ERROR;
          state.modalType = MODAL_TYPE_ALERT;
          
      },      
      hide(state, action) {
        state.showModal = false;
        state.header = "";
          state.description = "";
          state.type = "";
        state.modalType = null;
        state.status = null;
      }
      
    // omit existing reducers here
  },
  extraReducers(builder) {
     builder.addCase(loadTenants.fulfilled, (state, action) => {
      // We can directly add the new post object to our posts array

        state.status = UserConst.USER_STATE_IDLE
        state.error = null;

          state.showModal = true;
          state.modalType = MODAL_TYPE_TENANT_SELECT;
            state.data = action.payload;
            
        
      
    }).addCase(loadTenants.rejected, (state, action) => {
        state.status = UserConst.USER_STATE_ERROR
        state.error = action.payload;
      });
      
     builder.addCase(switchTenant.fulfilled, (state, action) => {
      // We can directly add the new post object to our posts array

        state.status = MODAL_TYPE_TENANT_CHANGED
        state.error = null;

          state.showModal = false;
          state.modalType = null;
            state.data = action.payload;
            
            
        
      
    }).addCase(switchTenant.rejected, (state, action) => {
        state.status = UserConst.USER_STATE_ERROR
        state.error = action.payload;
      });
      
      builder.addCase(LOCATION_CHANGE, (state, action) => {
             state.status = null;
      });
      
      
 } 
  
});
export const { show, hide, alert, info, success, error } = ModalReducer.actions;
export default ModalReducer.reducer